module.exports = __webpack_public_path__ + "static/media/consultoria_icon.a6494bf8.svg";